import React from 'react';

import { colorsPalette } from '../../theme';

const CirclePlusIcon = (props) => {
  const color = props?.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path
        d="M7.26467 3.66585H5.97578V6.33252H3.398V7.66585H5.97578V10.3325H7.26467V7.66585H9.84245V6.33252H7.26467V3.66585ZM6.62023 0.33252C3.06289 0.33252 0.175781 3.31919 0.175781 6.99919C0.175781 10.6792 3.06289 13.6659 6.62023 13.6659C10.1776 13.6659 13.0647 10.6792 13.0647 6.99919C13.0647 3.31919 10.1776 0.33252 6.62023 0.33252ZM6.62023 12.3325C3.77823 12.3325 1.46467 9.93919 1.46467 6.99919C1.46467 4.05919 3.77823 1.66585 6.62023 1.66585C9.46222 1.66585 11.7758 4.05919 11.7758 6.99919C11.7758 9.93919 9.46222 12.3325 6.62023 12.3325Z"
        fill={color ? color : colorsPalette.white}
      />
    </svg>
  );
};

export default CirclePlusIcon;
